import { CardV2 } from '@eppendorf/vnls-react-components-preview';
import type { PropsWithChildren } from 'react';

/** Dashboard composition; the component library owns the card surface and tokens. */
export function DashboardWidget({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return (
    <CardV2 as="section" className={`dashboard-widget ${className ?? ''}`}>
      {children}
    </CardV2>
  );
}
